import { useCallback, useState } from "react";

export function useBudgetRedistributeWizard() {
  const [isOpen, setIsOpen] = useState(false);
  const [initialSourceId, setInitialSourceId] = useState<number | "external_pool" | null>(null);

  const open = useCallback(function open(sourceId?: number | "external_pool") {
    setInitialSourceId(sourceId ?? null);
    setIsOpen(true);
  }, []);

  const close = useCallback(function close() {
    setIsOpen(false);
    setInitialSourceId(null);
  }, []);

  return { isOpen, initialSourceId, open, close };
}
